import { render, staticRenderFns } from "./IconExternalVideo.vue?vue&type=template&id=33703f42"
import script from "./IconExternalVideo.vue?vue&type=script&lang=js"
export * from "./IconExternalVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports